"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordType = void 0;
exports.isGraphicRecord = isGraphicRecord;
var RecordType;
(function (RecordType) {
    RecordType[RecordType["HEADER"] = 0] = "HEADER";
    RecordType[RecordType["COMPONENT"] = 1] = "COMPONENT";
    RecordType[RecordType["PIN"] = 2] = "PIN";
    RecordType[RecordType["IEEE_SYMBOL"] = 3] = "IEEE_SYMBOL";
    RecordType[RecordType["LABEL"] = 4] = "LABEL";
    RecordType[RecordType["BEZIER"] = 5] = "BEZIER";
    RecordType[RecordType["POLYLINE"] = 6] = "POLYLINE";
    RecordType[RecordType["POLYGON"] = 7] = "POLYGON";
    RecordType[RecordType["ELLIPSE"] = 8] = "ELLIPSE";
    RecordType[RecordType["PIECHART"] = 9] = "PIECHART";
    RecordType[RecordType["ROUND_RECTANGLE"] = 10] = "ROUND_RECTANGLE";
    RecordType[RecordType["ELLIPTICAL_ARC"] = 11] = "ELLIPTICAL_ARC";
    RecordType[RecordType["ARC"] = 12] = "ARC";
    RecordType[RecordType["LINE"] = 13] = "LINE";
    RecordType[RecordType["RECTANGLE"] = 14] = "RECTANGLE";
    RecordType[RecordType["SHEET_SYMBOL"] = 15] = "SHEET_SYMBOL";
    RecordType[RecordType["SHEET_ENTRY"] = 16] = "SHEET_ENTRY";
    RecordType[RecordType["POWER_PORT"] = 17] = "POWER_PORT";
    RecordType[RecordType["PORT"] = 18] = "PORT";
    RecordType[RecordType["UNKNOWN_LEGACY"] = 21] = "UNKNOWN_LEGACY";
    RecordType[RecordType["NO_ERC"] = 22] = "NO_ERC";
    RecordType[RecordType["NET_LABEL"] = 25] = "NET_LABEL";
    RecordType[RecordType["BUS"] = 26] = "BUS";
    RecordType[RecordType["WIRE"] = 27] = "WIRE";
    RecordType[RecordType["TEXT_FRAME"] = 28] = "TEXT_FRAME";
    RecordType[RecordType["JUNCTION"] = 29] = "JUNCTION";
    RecordType[RecordType["IMAGE"] = 30] = "IMAGE";
    RecordType[RecordType["SHEET"] = 31] = "SHEET";
    RecordType[RecordType["SHEET_NAME"] = 32] = "SHEET_NAME";
    RecordType[RecordType["FILE_NAME"] = 33] = "FILE_NAME";
    RecordType[RecordType["DESIGNATOR"] = 34] = "DESIGNATOR";
    RecordType[RecordType["BUS_ENTRY"] = 37] = "BUS_ENTRY";
    RecordType[RecordType["TEMPLATE"] = 39] = "TEMPLATE";
    RecordType[RecordType["PARAMETER"] = 41] = "PARAMETER";
    RecordType[RecordType["PARAMETER_SET"] = 43] = "PARAMETER_SET";
    RecordType[RecordType["IMPLEMENTATION_LIST"] = 44] = "IMPLEMENTATION_LIST";
    RecordType[RecordType["IMPLEMENTATION"] = 45] = "IMPLEMENTATION";
    RecordType[RecordType["MAP_DEFINER_LIST"] = 46] = "MAP_DEFINER_LIST";
    RecordType[RecordType["MAP_DEFINER"] = 47] = "MAP_DEFINER";
    RecordType[RecordType["IMPL_PARAMS"] = 48] = "IMPL_PARAMS";
    RecordType[RecordType["NOTE"] = 209] = "NOTE";
    RecordType[RecordType["SIGNAL_PROBE"] = 210] = "SIGNAL_PROBE";
    RecordType[RecordType["COMPILE_MASK"] = 211] = "COMPILE_MASK";
    RecordType[RecordType["HARNESS_CONNECTOR"] = 215] = "HARNESS_CONNECTOR";
    RecordType[RecordType["HARNESS_ENTRY"] = 216] = "HARNESS_ENTRY";
    RecordType[RecordType["HARNESS_TYPE"] = 217] = "HARNESS_TYPE";
    RecordType[RecordType["SIGNAL_HARNESS"] = 218] = "SIGNAL_HARNESS";
    RecordType[RecordType["CODE_SYMBOL"] = 220] = "CODE_SYMBOL";
    RecordType[RecordType["CODE_SYMBOL_ENTRY"] = 221] = "CODE_SYMBOL_ENTRY";
    RecordType[RecordType["CODE_SYMBOL_NAME"] = 222] = "CODE_SYMBOL_NAME";
})(RecordType || (exports.RecordType = RecordType = {}));
function isGraphicRecord(record) {
    return (record.recordType === RecordType.LINE ||
        record.recordType === RecordType.RECTANGLE ||
        record.recordType === RecordType.POLYLINE ||
        record.recordType === RecordType.POLYGON ||
        record.recordType === RecordType.ARC ||
        record.recordType === RecordType.BEZIER ||
        record.recordType === RecordType.ELLIPSE ||
        record.recordType === RecordType.ELLIPTICAL_ARC ||
        record.recordType === RecordType.ROUND_RECTANGLE);
}
//# sourceMappingURL=SchDocTypes.js.map